import { StorageLevel, StorageLevelV2 } from '@twaice-fe/shared/models';

export class StorageLevelIdentifierUtils {
  static toLevelString(
    level: StorageLevel | StorageLevelV2,
    capitalized: boolean = false,
    componentCount: number | undefined = undefined,
    includeCount: boolean = false
  ): string {
    if(!level) return
    let levelIdentifier = level as string;
    if (componentCount !== 1) {
      levelIdentifier = `${level}s`;
    }
    if (capitalized) {
      levelIdentifier = levelIdentifier.charAt(0).toUpperCase() + levelIdentifier.slice(1);
    }
    return includeCount && componentCount !== undefined ? `${componentCount} ${levelIdentifier}` : levelIdentifier;
  }
}
